export const TYPES = {
  reportes: "[REPORTES] Agregar los reportes en el store",
  reportesRango:
    "[REPORTES] Agregar los rangos de fecha para reportes en el store",
  reportesBorrar: "[REPORTES] Eliminar los reportes en el store",
};
